// fetch
import { getWithToken, postWithToken } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl } from './util.js';

/**
 * getLandingSettings
 * @param {*} token
 */
export async function getLandingSettings() {
  const url = getUrl(urls.getLandingInfo);
  return await getWithToken(url);
}

/**
 * setCareerSettings
 * @param {*} code
 * @returns
 */
export async function setCareerSettings(code) {
  const url = getUrl(urls.setCareerSettings);
  return await postWithToken(url, {
    code,
  });
}
/**
 * setModeSettings
 * @param {*} mode
 * @returns
 */
export async function setModeSettings(mode) {
  const url = getUrl(urls.setModeSettings);
  return await postWithToken(url, {
    mode,
  });
}
/**
 * submitTranslate
 * @param {*} params
 * @returns
 */
export async function submitTranslate(params) {
  const url = getUrl(urls.newTranslate);
  return await postWithToken(url, params);
}
/**
 * getRecommendModels
 * @param {*}
 * @returns
 */
export async function getRecommendModels() {
  const url = getUrl(urls.newTranslate);
  return await getWithToken(url);
}

/**
 * 获取风格强化数据列表
 * @param {
 * prompt: string,
 * curBaseModel: string,
 * curBaseType: number
 * }
 * @returns []
 */
export async function getStyleEnhanceList(params) {
  const url = getUrl(urls.getStyleEnhanceModels);
  return await postWithToken(url, params);
}
/**
 * 获取灵感库返图数据列表
 * @param {
 * uuid: string,
 * sortType: 0,
 * page: number,
 * pageSize: number,
 * }
 * @returns []
 */
export async function searchModelGalleryList(params = {}) {
  const url = getUrl(urls.searchModelGalleryList);
  return await postWithToken(url, {
    sortType: 0,
    ...params,
  });
}

export async function gallerySubscribe(params = {}) {
  const url = getUrl(urls.gallerySubscribe);
  return await postWithToken(url, {
    ...params,
  });
}
export async function galleryUnsubscribe(params = {}) {
  const url = getUrl(urls.galleryUnsubscribe);
  return await postWithToken(url, {
    ...params,
  });
}
export async function getGallerySubscribeList(params = {}) {
  const url = getUrl(urls.getGallerySubscribeList);
  return await postWithToken(url, {
    ...params,
    subscribeType: 1,
  });
}
